import { render } from "./YandexMapSmall.vue?vue&type=template&id=71a8d956&scoped=true"
import script from "./YandexMapSmall.vue?vue&type=script&lang=js"
export * from "./YandexMapSmall.vue?vue&type=script&lang=js"

import "./YandexMapSmall.vue?vue&type=style&index=0&id=71a8d956&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71a8d956"]])

export default __exports__